import TagManager from 'react-gtm-module';

export const trackStoreAvailabilityModalOpenEvent = ({
  storeName,
}: {
  storeName: string;
}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_store_avail_modal',
      interaction: {
        store_name: storeName,
      },
    },
  });
};

export const trackStoreAvailabilityModalChangeStoreEvent = ({
  newlySelectedStore,
  previouslySelectedStore,
}: {
  newlySelectedStore: string;
  previouslySelectedStore: string;
}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'change_store_avail_modal',
      interaction: {
        link_text: newlySelectedStore,
        store_name: previouslySelectedStore,
      },
    },
  });
};
